import { viewsetDuck } from '@/shared/ducks/viewsetDuck'

export const DEFAULT_STATE = {}

export const duck = viewsetDuck('staffOrganizationUnits', '/mgmt/api/organization-units/')

export const { actionTypes, actions, reducer, useAPI } = duck

export default duck
